export const PLUGIN_MENU_MODAL_ID = 'pluginMenu';

export const PLUGIN_MENU_HORIZONTAL_MODAL_ID = 'pluginMenuHorizontal';
